/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from '../../scss/common/style';

interface Props {
  text: string;
  code: string;
  background?: string;
}

export default function GtinComponent({ text, code, background }: Props): JSX.Element {
  return (
    <Container>
      {text && <StyledText>{text}</StyledText>}
      {code && <Barcode background={background}>{code}</Barcode>}
    </Container>
  );
}

const StyledText = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  background: #343434;
  color: #fff;
  border-radius: 5px;
  margin: 0;
  width: 25px;
  height: 20px;
`;

const Barcode = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
  color: #343434;
  background: ${(props) => (props.background ? props.background : '#fff')};
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  margin: 0;
  padding: 1px 5px;
  height: 20px;
`;

const Container = styled.div`
  height: 20px !important;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: fit-content;
  align-items: center;
  background: #fff;
  margin-right: 3px;
  margin: 2px;
`;
